export const REQUEST_SUBJECT = `Купить в 1 клик`;
